// extracted by mini-css-extract-plugin
module.exports = {"border":"InstructorBio_border__bd_dT","instructorWrapper":"InstructorBio_instructorWrapper__3VdBI","nameplate":"InstructorBio_nameplate__psrs_"};